// Calendar configuration constants
export const CALENDAR_CONSTANTS = {
  SLOT_DIMENSIONS: {
    WIDTH: 75,
    HEIGHT: 40,
  },
} as const

// Weekday configuration
export const WEEKDAYS = [
  { weekday: 1, translationKey: 'weekdays.monday' },
  { weekday: 2, translationKey: 'weekdays.tuesday' },
  { weekday: 3, translationKey: 'weekdays.wednesday' },
  { weekday: 4, translationKey: 'weekdays.thursday' },
  { weekday: 5, translationKey: 'weekdays.friday' },
  { weekday: 6, translationKey: 'weekdays.saturday' },
  { weekday: 7, translationKey: 'weekdays.sunday' },
] as const
